module.exports = __webpack_public_path__ + "img/avatar.4a05bc5e.svg";